import { motion, AnimatePresence } from "framer-motion";

interface ToastProps {
  toast: { id: number; title: string; message?: string } | null;
}

export function Toast({ toast }: ToastProps) {
  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="fixed bottom-6 right-4 z-[80] bg-primary text-white border border-white/20 rounded-xl shadow-xl px-4 py-3 max-w-sm pointer-events-auto"
        >
          <div className="text-sm font-semibold">{toast.title}</div>
          {toast.message && (
            <div className="text-xs text-gray-100 mt-1">{toast.message}</div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
